export default __webpack_public_path__ + "static/media/talikora-hari-krishna.d8b502f9.png";